@if (document) {
  <div>
    <app-document-editform [editedDocument]="document"> </app-document-editform>
  </div>
}
